<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i class="fa fa-times" (click)="cancel()" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  <form novalidate autocomplete="off">
    <div class="form-group">
      <label class="control-label"><strong>Adjustment Amount:</strong></label>
      <input type="text" class="form-control" [(ngModel)]="ADJ_AMT" name="adj_amt" placeholder="">
    </div>
    <div class="form-group">
      <label class="control-label"><strong>Comments:</strong></label>
      <textarea class="form-control" [(ngModel)]="COMMENTS" name="comments"></textarea>
    </div>
    <div class="form-group">
      <label class="control-label"><strong>Updated By:</strong></label>
      <span><strong>{{ USER_UPDATED }}</strong></span>
    </div>
    <div class="form-group">
      <label class="control-label"><strong>Updated On:</strong></label>
      <span><strong>{{ DATE_UPDATED }}</strong></span>
    </div>
    <div class="modal-footer">
      <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save Adjustments
      </button>
      <button class="reset-button" type="button" (click)="reset()">Reset Form</button>
      <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
    </div>
  </form>
</div>
